<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dealerProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dealerProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-tooltip="$t('dealerProfile.search')"
              v-model="search"
              :placeholder="$t('dealerProfile.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
        >
          <template v-slot="{ record }">
            <td>{{ record.dealer_code }}</td>
            <td>{{ record.dealer_name }}</td>
            <td>{{ record.dealer_type.dealer_type }}</td>
            <td>{{ record.parent_name }}</td>
            <td>{{ record.owner_name }}</td>
            <td>
              <p class="ts-mb-0">{{ record.primary_contact }}</p>
              <p class="ts-mb-0">{{ record.secondary_contact }}</p>
            </td>
            <td>{{ record.topup_commission_rate }}</td>
            <td>{{ record.payout_commission_rate }}</td>
            <td class="text-right">{{ record.main_balance }}</td>
            <td class="text-right">{{ record.payout_balance }}</td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Reason from './components/reason_delete'

export default {
  name: 'dealerProfile',
  components: {
    Reason
  },
  data() {
    return {
      loading: false,
      create_frm: false,
      errors: new Errors(),
      model: {
        deleted_reason: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/dealerProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.dealerProfile.search
      },
      set(newValue) {
        this.$store.commit('administrator/dealerProfile/SET_SEARCH', newValue)
        this.$store.commit('administrator/dealerProfile/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('dealerProfile.dealerCode') },
        { name: this.$t('dealerProfile.dealerName') },
        { name: this.$t('dealerProfile.type') },
        { name: this.$t('dealerProfile.parent') },
        { name: this.$t('dealerProfile.ownerName') },
        { name: this.$t('dealerProfile.contact') },
        { name: this.$t('dealerProfile.topUpRate') },
        { name: this.$t('dealerProfile.payOutRate') },
        { name: this.$t('dealerProfile.mainBalance'), style: 'text-align:right' },
        { name: this.$t('dealerProfile.payout'), style: 'text-align:right' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    ...mapActions('administrator/dealerProfile', ['destroy']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/dealerProfile/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'dealer-profile-create' })
    },
    edit(record) {
      this.$store.commit('administrator/dealerProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'dealer-profile-edit',
        params: { id: record.dealer_id }
      })
    },
    onClose() {
      this.create_frm = false
      this.fetchData()
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('dealerProfile.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.destroy({
            id: record.dealer_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/dealerProfile/RESET_STATE')
    next()
  }
}
</script>
